export default __webpack_public_path__ + "static/media/tiny3.79d4a081.jpg";